'use strict';

exports.__esModule = true;

var _wendysKennyLoggins = require('wendys-kenny-loggins');

var _logAppender = require('./log.appender.factory');

var _logAppender2 = _interopRequireDefault(_logAppender);

var _logSession = require('./log.session.identity');

var _logSession2 = _interopRequireDefault(_logSession);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var elkLogConfiguration = function () {
    /**
     * ELK Base Logging Configuration for Web
     * @param applicationId {string}
     * @param environment {string}
     * @returns {elkLogConfiguration}
     * @description Base configuration instance. Returns null if no application ID provided
     */
    function elkLogConfiguration(applicationId, environment) {
        _classCallCheck(this, elkLogConfiguration);

        this.sessionIdentity = null;
        this.applicationId = '';
        this.environment = '';
        this.loggingConfig = {};
        this.appenderConfigs = {};
        this.requestFormatter = {
            name: 'req',
            format: function format(req) {
                return {
                    headers: req.headers,
                    method: req.method,
                    payload: req.payload,
                    queryString: req.queryString,
                    url: req.url
                };
            }
        };
        this.responseFormatter = {
            name: 'res',
            format: function format(res) {
                return {
                    headers: res.headers,
                    serviceStatus: res.body.serviceStatus,
                    serviceMessages: res.body.serviceMessages ? res.body.serviceMessages : [],
                    statusCode: res.status,
                    statusText: res.statusText
                };
            }
        };
        this._loggerModelPropertyList = ['name', 'appenders', 'level'];

        if (!!!applicationId) throw 'Missing Parameter Exceptions: application Id required';

        this.applicationId = applicationId;
        this.environment = environment || 'DEV';
        this.sessionIdentity = new _logSession2.default();
        this.appenderConfigs = this._initAppenderConfigs();
        this.loggingConfig = this._initLoggingConfig();
    }

    /**
     * Session Identity
     * @type {logSessionIdentity}
     * @description identity class used to associate logged events to a common UTC Timestamp key property prior to initialization
     * of more common deviceId or token properties. Initialized on instantiation.
     */


    /**
     * Defined application id
     * @type {string}
     * @description initialized in constructor
     */


    /**
     * Current environment
     * @type {string}
     * @description initialized in constructor
     */


    /**
     * Initialized Logging Configuration
     * @type {object}
     * @description due to scoping limitations, initialization was moved into
     * a helper routine which is initialized from the constructor
     */


    /**
     * Appender Configuration for each environment
     * @type {object}
     * @description initialized from the constructor using helper routine
     */


    /**
     * Base Request Formatter
     * @type {object}
     */


    /**
     * Base Response Formatter
     * @type {object}
     */


    /**
     * Logger Model Properties
     * @type {array[string]}
     * @private
     */


    /**
     * Set application specific loggers from array
     * @param loggerCollection {array[object]}
     * @description this already contains an instance of the ajaxAppender
     * for common-web
     */
    elkLogConfiguration.prototype.setApplicationSpecificLoggers = function setApplicationSpecificLoggers(loggerCollection) {
        var _this = this;

        if (!Array.isArray(loggerCollection) || !loggerCollection.length) throw 'no logger was created, expecting array';

        loggerCollection.forEach(function (logger) {
            _this._addLoggersToEnvironmentCollection(logger);
        });
    };

    /**
     * Replace default implemented loggers with a environment specific collection
     * @param loggerCollection {array[object]}
     */


    elkLogConfiguration.prototype.replaceApplicationLoggers = function replaceApplicationLoggers(loggerCollection) {
        var _isCollection = Array.isArray(loggerCollection) && loggerCollection.length;
        var _loggerModelIsValid = _isCollection && this._validateModelProperties(loggerCollection[0], this._loggerModelPropertyList);

        if (!_loggerModelIsValid) throw 'no logger was created, expecting array';

        this.loggingConfig[this.environment].loggers = loggerCollection;
    };

    /**
     * Process application logger assignment
     * @param logger {object}
     * @private
     * @description provides failover for invalid loggers
     */


    elkLogConfiguration.prototype._addLoggersToEnvironmentCollection = function _addLoggersToEnvironmentCollection(logger) {
        var _environment = this.loggingConfig[this.environment];
        var _loggerModelIsValid = !!logger && this._validateModelProperties(logger, this._loggerModelPropertyList);

        if (!_loggerModelIsValid) return;

        if (!_environment.hasOwnProperty('loggers')) _environment.loggers = [];

        _environment.loggers.push(logger);
    };

    /**
     * Initialization Routine for Logging Configuration
     * @returns {object}
     * @private
     */


    elkLogConfiguration.prototype._initLoggingConfig = function _initLoggingConfig() {
        var _localFormatters = [this.responseFormatter, this.requestFormatter];
        var _localAppenders = [_logAppender2.default.ajaxAppender()];
        var _localApplicationId = this.applicationId;

        var _configObjectModel = {
            formatters: _localFormatters,
            loggers: [{
                name: '^common-web.*',
                appenders: _localAppenders,
                level: _wendysKennyLoggins.Level.INFO
            }],
            globals: { appId: _localApplicationId }
        };

        return {
            LOCAL: _configObjectModel,
            DEV: _configObjectModel,
            TEST: _configObjectModel,
            PQA: _configObjectModel,
            PROD: _configObjectModel
        };
    };

    /**
     * Initialization Routine for Appender Configuration for each environment
     * @returns {object}
     */


    elkLogConfiguration.prototype._initAppenderConfigs = function _initAppenderConfigs() {
        var _common = _logAppender2.default.ajaxAppenderEndpointConfig;
        return {
            LOCAL: _common,
            DEV: _common,
            TEST: {},
            PQA: {},
            PROD: {}
        };
    };

    /**
     * Validate Properties Exist for Model
     * @param model {object}
     * @param propertiesToValidate {array[*]}
     * @returns {boolean}
     * @private
     */


    elkLogConfiguration.prototype._validateModelProperties = function _validateModelProperties(model, propertiesToValidate) {
        if (!!!model || !Array.isArray(propertiesToValidate)) return false;

        var _isValid = true;
        if (Array.isArray(propertiesToValidate)) {
            propertiesToValidate.forEach(function (property) {
                if (!model.hasOwnProperty(property)) _isValid = false;
            });
        }

        return _isValid;
    };

    return elkLogConfiguration;
}();

exports.default = elkLogConfiguration;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/elk/log.configuration.js
// module id = 893
// module chunks = 0